import React, { FC, useState, useEffect } from 'react';
import { useIntersect } from '@wix/experts-common';
import { Box } from '@wix/design-system';
import MobileFilterButton from '../MobileFilters/MobileFilterButton';
import CurrencySettings from '@components/Explore/CurrencySettings';
import s from './MobileFiltersAndActions.module.scss';

const MobileFiltersAndActions: FC = () => {
  const [ref, entry] = useIntersect({}) as any;

  const [showShadow, setShowShadow] = useState(false);
  useEffect(() => {
    if (entry.intersectionRatio < 1) {
      setShowShadow(true);
    } else {
      setShowShadow(false);
    }
  }, [entry]);

  return (
    <div
      className={showShadow ? `${s.stickyNav} ${s.showShadow}` : s.stickyNav}
      ref={ref}
    >
      <Box margin="0 auto" maxWidth="504px">
        <Box paddingTop="2px" height="54px" verticalAlign="middle">
          <Box align="left" gap="SP2">
            <MobileFilterButton />
            <CurrencySettings isMobileView={true} />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default MobileFiltersAndActions;
